import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  clearPossibleSelections as clearDownDistancePossibleSelections,
  clearSelections as clearDownDistanceSelections,
} from '../../state/downDistance';

import {
  clearPossibleSelections as clearFieldZonePossibleSelections,
  clearSelections as clearFieldZoneSelections,
} from '../../state/fieldZone';

import { SPORT_TYPE_FOOTBALL } from '../../constants/sports';
import getSportType from '../../state/selectors/getSportType';
import FootballPlayFilterPane from './FootballPlayFilterPane';
import { getQlikAppId } from '../../state/selectors/getQlikAppId';

class PlayFilterPane extends PureComponent {
  componentDidUpdate() {
    const {
      qlikAppId,
      clearDownDistancePossibleSelections,
      clearDownDistanceSelections,
      clearFieldZonePossibleSelections,
      clearFieldZoneSelections,
    } = this.props;

    if (!qlikAppId) {
      clearDownDistanceSelections();
      clearDownDistancePossibleSelections();
      clearFieldZoneSelections();
      clearFieldZonePossibleSelections();
    }
  }

  render() {
    const { sport, qlikAppId } = this.props;

    if (!qlikAppId) {
      return null;
    }

    switch (sport) {
      case SPORT_TYPE_FOOTBALL:
        return <FootballPlayFilterPane />;
      default:
        return null;
    }
  }
}

PlayFilterPane.propTypes = {
  qlikAppId: PropTypes.string.isRequired, // supplied from Redux
  sport: PropTypes.string.isRequired, // supplied from Redux
  clearDownDistanceSelections: PropTypes.func.isRequired, // supplied from Redux
  clearDownDistancePossibleSelections: PropTypes.func.isRequired, // supplied from Redux
  clearFieldZoneSelections: PropTypes.func.isRequired, // supplied from Redux
  clearFieldZonePossibleSelections: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  qlikAppId: getQlikAppId(state),
  sport: getSportType(state),
});

const mapDispatchToProps = {
  clearDownDistanceSelections,
  clearDownDistancePossibleSelections,
  clearFieldZoneSelections,
  clearFieldZonePossibleSelections,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayFilterPane);
